<!-- <app-splash-screen></app-splash-screen> -->
<router-outlet></router-outlet>
<ngx-ui-loader fgsColor="Gray"></ngx-ui-loader>
